import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { Loader2, Plus, Trash2, Calendar } from "lucide-react";

export default function Events() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ title: "", description: "", date_text: "", send_email_at: "" });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/admin/events"); setItems(r.data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.title || !form.send_email_at) return;
    setSaving(true);
    try {
      // Convert local datetime-local input to ISO with timezone
      const iso = new Date(form.send_email_at).toISOString();
      await api.post("/admin/events", { ...form, send_email_at: iso });
      setForm({ title: "", description: "", date_text: "", send_email_at: "" });
      await load();
    } finally { setSaving(false); }
  };
  const del = async (id) => { await api.delete(`/admin/events/${id}`); await load(); };

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-6 py-10">
        <button onClick={() => nav("/pos/dashboard")} className="label-eyebrow mb-6 inline-block" data-testid="ev-back">← Back</button>
        <div className="flex items-center gap-3 mb-3">
          <Calendar size={26} style={{ color: "var(--ab-primary)" }} />
          <h1 className="font-display text-4xl font-black">Events</h1>
        </div>
        <p className="text-sm max-w-xl mb-8" style={{ color: "var(--ab-text-muted)" }}>
          Schedule an email broadcast to all AB Members. Set the title, description, and the date/time you want the email to go out.
        </p>

        <form onSubmit={add} className="surface p-5 space-y-3 mb-6" data-testid="ev-form">
          <div><label className="label-eyebrow block mb-1">Title</label>
            <input className="input-terminal" required value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} data-testid="ev-title" /></div>
          <div><label className="label-eyebrow block mb-1">Event Date (display text, e.g. "Saturday, March 15 at 7 PM")</label>
            <input className="input-terminal" value={form.date_text} onChange={(e) => setForm({...form, date_text: e.target.value})} data-testid="ev-date-text" /></div>
          <div><label className="label-eyebrow block mb-1">Description</label>
            <textarea className="input-terminal" rows={4} value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} data-testid="ev-desc" /></div>
          <div><label className="label-eyebrow block mb-1">Send Email At</label>
            <input type="datetime-local" className="input-terminal" required value={form.send_email_at} onChange={(e) => setForm({...form, send_email_at: e.target.value})} data-testid="ev-send-at" /></div>
          <button className="btn-primary inline-flex items-center gap-2" disabled={saving} data-testid="ev-add">{saving ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />} Schedule Event</button>
        </form>

        {loading ? <Loader2 className="animate-spin" /> : items.length === 0 ? (
          <div className="surface p-6 text-sm" style={{ color: "var(--ab-text-muted)" }} data-testid="ev-empty">No events scheduled.</div>
        ) : (
          <div className="surface divide-y" style={{ borderColor: "var(--ab-border)" }}>
            {items.map((ev) => (
              <div key={ev.id} className="px-5 py-4 flex items-start gap-3" data-testid={`ev-row-${ev.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="font-bold">{ev.title}</div>
                  <div className="text-xs" style={{ color: "var(--ab-text-dim)" }}>Send at: {ev.send_email_at} {ev.sent_at ? ` · sent ${ev.sent_at}` : ""}</div>
                  {ev.date_text && <div className="text-xs mt-1">{ev.date_text}</div>}
                </div>
                <button onClick={() => del(ev.id)} className="btn-danger" style={{ padding: "6px 12px", fontSize: 11 }} data-testid={`ev-del-${ev.id}`}><Trash2 size={12} /></button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
